import React, {Suspense} from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Home from "../pages/Home"
import { Styles } from "../styles/styles";
import Datenschutz from "../pages/Datenschutz";
import Impressum from "../pages/Impressum";
import Newsletter from "../components/Newsletter";
import NewsletterAbmeldung from "../components/NewsletterAbmeldung";
import Newsletter01 from "../pages/Newsletter01";
import Newsletter02 from "../pages/Newsletter02";
import Newsletter03 from "../pages/Newsletter03";

const Router = () => {
    const location = useLocation();
    const hideFooter = location.pathname.startsWith("/newsletter/");

    return (
    <Suspense fallback={null}>
      <Styles />
      <Header />
      {/* <NewsLine/> */}
      <Routes>
        <Route 
          path = "*" 
          element = {<p>There's nothing here: 404!</p>}
        />
        <Route 
          index  element = {<Home/>}
        />
        <Route 
          path = "home" 
          element = {<Home/>}
        />      
        <Route 
          path = "datenschutz" 
          element = {<Datenschutz/>}
        />
        <Route 
          path = "impressum" 
          element = {<Impressum/>}
        />
          <Route
              path = "newsletter"
              element = {<Newsletter/>}
          />
          <Route
              path = "newsletter/1-2024"
              element = {<Newsletter01/>}
          />
          <Route
              path = "newsletter/2"
              element = {<Newsletter02/>}
          />
        <Route
              path = "newsletter/3"
              element = {<Newsletter03/>}
          />
          <Route
              path = "abmeldung-newsletter"
              element = {<NewsletterAbmeldung/>}
          />
      </Routes>
      {!hideFooter && <Footer />}
      {/* <Button 
        onClick = {changeState}
      >Zeige Impressum und Datenschutz</Button>
      <Appendix state = {state}/> */}
    </Suspense>
  );
};

export default Router;
